import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex w-100" }
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = {
  key: 0,
  class: "ml-2 action-icon",
  style: {"width":"1.5em"}
}
const _hoisted_4 = {
  class: "ml-1 action-icon",
  style: {"width":"1.5em"}
}
const _hoisted_5 = {
  class: "ml-1 action-icon",
  style: {"width":"1.5em"}
}
const _hoisted_6 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_7 = { class: "text-muted" }

import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import {computed, inject} from "vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import {__} from "~/ts/library/Translate";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {
    DataProviderManageEntityTabInjection
} from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/editTab/Inteface";
import ClientInfoDataProviderCardEntityType
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/ClientInfoDataProviderCardEntityType.vue";
import OperatorApiRequestFactory from "~/operatorApplication/ts/request/OperatorApiRequestFactory";
import {AbstractApiResult} from "~/core-ui/ts/request/AbstractApiResult";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import DataProviderLogDialog
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/log/DataProviderLogDialog.vue";


import {ref} from 'vue';
import Dictionary from "~/ts/library/Dictionary";

let dataProviderAuthCollapsed = ref<Dictionary<boolean>>({});

const __default__ = {
    name: "ClientInfoDataProviderCard"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    platform: {},
    integration: {},
    showAuthTitle: { type: Boolean }
  },
  setup(__props: any) {

let props = __props;

let openManageDataProviderEntity = inject(DataProviderManageEntityTabInjection, null);

let collapsedKey = computed(() => `${props.platform.id}_${props.integration.authPrimaryId}`);

function setCollapsed(value: boolean) {
    dataProviderAuthCollapsed.value[collapsedKey.value] = value;
}

let isCollapsed = computed(() => {
    let key = collapsedKey.value;
    if (!dataProviderAuthCollapsed.value.hasOwnProperty(key)) {
        setCollapsed(false);
    }
    return dataProviderAuthCollapsed.value[key];
});

let entityTypesDictionary = computed(() => ObjectHelper.dictionaryFromArray(props.integration.dataProviderPlatformData.entityTypes));

let entityHistory = computed(() => {
    return props.userdata.dataProviderEntityHistory
        .filter(item => item.platformId == props.platform.id && item.authPrimaryId == props.integration.authPrimaryId)
        .filter(item => !!entityTypesDictionary.value[item.entityTypeId])
        .sort((a, b) => {
            let aId = parseInt(a.entityId);
            let bId = parseInt(b.entityId);
            if (!isNaN(aId) && !isNaN(bId)) {
                return aId < bId ? 1 : -1;
            }
            return a.entityId < b.entityId ? 1 : -1;
        });
});

function getHistoryByEntityType(entityTypeId: string) {
    return entityHistory.value.filter(item => item.entityTypeId == entityTypeId);
}

let entityTypesForCreate = computed(() => props.integration.dataProviderPlatformData.entityTypes.filter(type => type.isCreateAvailable));

function openEntityManageDialog(typeId: string, entityId?: string | number) {
    let type = props.integration.dataProviderPlatformData.entityTypes.find(type => type.id == typeId);
    if (type) {
        openManageDataProviderEntity({
            platform: props.platform,
            entityType: type,
            integration: props.integration,
            entityId
        });
    }
}

let logDisplayed = ref(false);

async function searchInDataProvider() {
    let p: OperatorApplicationApi.OperatorDataProviderMakeSearchOpenApiModel = {
        username: props.userdata.username,
        authPrimaryId: props.integration.authPrimaryId,
        platformId: props.platform.id
    };
    let result = await OperatorApiRequestFactory.create<OperatorApplicationApi.OperatorDataProviderGetEntityByIdResultOpenApiModel>({
        url: "/dataProvider/makeSearch",
        p
    }).send();
    if (result.isSuccess) {
        AbstractApiResult.showMessage(__("Задача поставлена в очередь"), "success");
    } else {
        result.showMessage();
    }
}

async function removeNonExist(validate: boolean) {
    let p: OperatorApplicationApi.OperatorDataProviderRemoveNonActualOpenApiModel = {
        username: props.userdata.username,
        authPrimaryId: props.integration.authPrimaryId,
        platformId: props.platform.id,
        validate
    };
    let result = await OperatorApiRequestFactory.create<OperatorApplicationApi.OperatorDataProviderRemoveNonActualResultOpenApiModel>({
        url: "/dataProvider/removeNonActual",
        p
    }).send();
    if (result.isSuccess) {
        if (validate) {
            try {
                await ElConfirm(result.data.confirmText);
                removeNonExist(false);
            } catch (e) {
            }
        } else {
            result.showMessage();
        }
    } else {
        if (result.data.confirmText) {
            AbstractApiResult.showMessage(result.data.confirmText, "success");
        } else {
            result.showMessage();
        }
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createBlock(SideMenuCard, {
    class: "info",
    collapsed: _unref(isCollapsed),
    "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => (setCollapsed($event)))
  }, _createSlots({
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.platform.descr) + " ", 1),
          (__props.showAuthTitle)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" - " + _toDisplayString(__props.integration.descr), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (__props.integration.dataProviderPlatformData?.isSearchConfigured)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                link: "",
                class: "pt-0 pb-0 h-auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, { icon: "search" })
                ]),
                _: 1
              })), [
                [_directive_my_tooltip, _unref(__)('Поиск в %s',__props.platform.descr)],
                [
                  _directive_on_native,
                  searchInDataProvider,
                  "click",
                  { stop: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            link: "",
            class: "pt-0 pb-0 h-auto"
          }, {
            default: _withCtx(() => [
              _createVNode(FontAwesomeIcon, { icon: "recycle" })
            ]),
            _: 1
          })), [
            [_directive_my_tooltip, _unref(__)('Удалить неактуальные')],
            [
              _directive_on_native,
              () => removeNonExist(true),
              "click",
              { stop: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            link: "",
            class: "pt-0 pb-0 h-auto"
          }, {
            default: _withCtx(() => [
              _createVNode(FontAwesomeIcon, { icon: "scroll" })
            ]),
            _: 1
          })), [
            [_directive_my_tooltip, _unref(__)('Логи')],
            [
              _directive_on_native,
              () => _isRef(logDisplayed) //@ts-ignore
 ? logDisplayed.value = true : logDisplayed = true,
              "click",
              { stop: true }
            ]
          ]),
          (_unref(logDisplayed))
            ? (_openBlock(), _createBlock(DataProviderLogDialog, {
                key: 0,
                visible: _unref(logDisplayed),
                "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(logDisplayed) ? (logDisplayed).value = $event : logDisplayed = $event)),
                "platform-id": __props.integration.platformId,
                "auth-primary-id": __props.integration.authPrimaryId,
                username: __props.userdata.username
              }, null, 8, ["visible", "platform-id", "auth-primary-id", "username"]))
            : _createCommentVNode("", true)
        ]),
        (_unref(openManageDataProviderEntity) && _unref(entityTypesForCreate).length > 0)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_dropdown, {
                trigger: "click",
                onCommand: _cache[1] || (_cache[1] = ($event: any) => (openEntityManageDialog($event, null)))
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { disabled: "" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(__)('Создать в %s', __props.platform.descr)), 1)
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(entityTypesForCreate), (type) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          key: type.id,
                          command: type.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(type.descr), 1)
                          ]),
                          _: 2
                        }, 1032, ["command"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      link: "",
                      class: "pt-0 pb-0 h-auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(FontAwesomeIcon, { icon: "plus" })
                      ]),
                      _: 1
                    })), [
                      [_directive_my_tooltip, _unref(__)('Создать в %s', __props.platform.descr)]
                    ])
                  ])
                ]),
                _: 1
              })
            ])), [
              [
                _directive_on_native,
                void 0,
                "click",
                { stop: true }
              ]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    append: _withCtx(() => [
      (_unref(entityHistory).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.integration.dataProviderPlatformData.entityTypes, (entityType) => {
            return (_openBlock(), _createBlock(ClientInfoDataProviderCardEntityType, {
              "history-items": getHistoryByEntityType(entityType.id),
              "entity-type": entityType,
              userdata: __props.userdata,
              platform: __props.platform,
              onManage: ($event: any) => (openEntityManageDialog(entityType.id, $event))
            }, null, 8, ["history-items", "entity-type", "userdata", "platform", "onManage"]))
          }), 256))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (!_unref(entityHistory).length)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _createVNode(SideMenuCardSection, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(__)("Клиент пока не выгружался")), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["collapsed"]))
}
}

})